var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"14","height":"10"}},[_c('path',{attrs:{"d":"m 13.694744,1.3660405 -13.389488,0 C 2.5368371,3.7886804 4.7684185,6.21132 7,8.6339595 9.2315825,6.2113209 11.463163,3.7886805 13.694744,1.3660405 Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }